/**
 * Errors on the players' pages reach the server's log (otherwise a frozen screen on someone's phone is
 * invisible to us): uncaught errors, rejected promises, and what the frame loop catches. The same error
 * is sent once, and a page sends at most a handful.
 */
const MAX = 5;
const sent = new Set<string>();

export const reportError = (e: unknown, where = 'error'): void => {
  if (import.meta.env.DEV || sent.size >= MAX) return;
  const err = e instanceof Error ? e : new Error(String(e));
  const key = `${where}|${err.message}`;
  if (sent.has(key)) return;
  sent.add(key);
  const body = JSON.stringify({
    where,
    message: err.message.slice(0, 300),
    stack: (err.stack ?? '').split('\n').slice(0, 8).join('\n').slice(0, 1500),
    build: __BUILD__,
    page: location.pathname,
    agent: navigator.userAgent.slice(0, 200),
  });
  try {
    void fetch('/api/client-error', { method: 'POST', headers: { 'content-type': 'application/json' }, body, keepalive: true }).catch(() => undefined);
  } catch {
    /* nothing to do */
  }
};

export const watchErrors = (): void => {
  window.addEventListener('error', (ev) => reportError(ev.error ?? ev.message, 'window'));
  window.addEventListener('unhandledrejection', (ev) => reportError(ev.reason, 'promise'));
};
